import React from 'react'

const SubClinicTrainerList = () => {
  return (
    <div>SubClinicTrainerList</div>
  )
}

export default SubClinicTrainerList